export const modalCustomizations = {
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.mode === 'light' ? '#FCFCFC' : '#000000',
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.mode === 'light' ? '#FCFCFC' : '#000000',
        borderRadius: 8,
      }),
    },
  },
};
